import { useRestApi } from './use-rest-api.hook';
import { useAppConfigContext } from '@vivli/core/infrastructure/context';

export const useAnonRestApi = () => {
    const config = useAppConfigContext();

    return useRestApi({ endpoint: `${config?.apiUri}api` });
};
